function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useMemo, useState } from 'react';
import './DateFilter.module.scss';
import whitelistProps from '../../../utils/whitelistProps';
import en from '../locales/ImmersiveSubheader.en.json';
import AnchorButton from '../../../Buttons/AnchorButton/AnchorButton';
import { ModalHeader } from '../../../Modal/ModalHeader/ModalHeader';
import ModalBody from '../../../Modal/ModalBody/ModalBody';
import ModalFooter from '../../../Modal/ModalFooter/ModalFooter';
import ButtonGroup from '../../../Buttons/ButtonGroup/ButtonGroup';
import ButtonLabel from '../../../Buttons/ButtonLabel/ButtonLabel';
import Modal from '../../../Modal/Modal/Modal';
import Button from '../../../Buttons/Button/Button';
import I18n from '../../../I18n/I18n/I18n';
import { injectIntl } from 'react-intl';
import IconButton from '../../../Buttons/IconButton/IconButton';
import DateInput from '../../../Inputs/DateInput/DateInput';
import styles from './DateFilter.module.scss';
import H from '../../../H/H';
import compose from '../../../utils/compose';
import { withAdditionalIntl } from '../../../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import ModalWrapper from '../../../Modal/ModalWrapper/ModalWrapper';
var whitelist = whitelistProps('onChange');
var messages = normalizeLocaleData(en, '@dm/components.immersiveSubheader');
export function DateFilter(_ref) {
  var _ref$startDate = _ref.startDate,
    startDate = _ref$startDate === void 0 ? '' : _ref$startDate,
    _ref$endDate = _ref.endDate,
    endDate = _ref$endDate === void 0 ? '' : _ref$endDate,
    onChange = _ref.onChange,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    } : _ref$dateFormat,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-us' : _ref$locale,
    _ref$delimiter = _ref.delimiter,
    delimiter = _ref$delimiter === void 0 ? '/' : _ref$delimiter,
    attrs = _objectWithoutProperties(_ref, ["startDate", "endDate", "onChange", "dateFormat", "locale", "delimiter"]);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dateRangeErrorMsg = _useState2[0],
    setDateRangeErrorMsg = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    startDateErrorMsg = _useState4[0],
    setStartDateErrorMsg = _useState4[1];
  var startDateArray = startDate ? startDate.split(delimiter) : [];
  var _useState5 = useState(startDate ? startDateArray[2] + '-' + startDateArray[0] + '-' + startDateArray[1] : null),
    _useState6 = _slicedToArray(_useState5, 2),
    startDateObj = _useState6[0],
    setStartDateObj = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    endDateErrorMsg = _useState8[0],
    setEndDateErrorMsg = _useState8[1];
  var endDateArray = endDate ? endDate.split(delimiter) : [];
  var _useState9 = useState(endDate ? endDateArray[2] + '-' + endDateArray[0] + '-' + endDateArray[1] : null),
    _useState0 = _slicedToArray(_useState9, 2),
    endDateObj = _useState0[0],
    setEndDateObj = _useState0[1];
  var additionalAttrs = whitelist(attrs);
  var formatDate = function formatDate(date, locale, format) {
    var formattedDate = null;
    if (date) {
      var tempDate = new Date();
      var dateArray = date.split('-');
      tempDate.setFullYear(parseInt(dateArray[0]), parseInt(dateArray[1]) - 1, parseInt(dateArray[2]));
      formattedDate = tempDate.toLocaleDateString(locale, format);
    }
    return formattedDate;
  };
  var dateRange = useMemo(function () {
    return {
      id: '@dm/components.immersiveSubheader.date-filter.value',
      values: {
        allDates: startDate || endDate ? 1 : 0,
        startDate: formatDate(startDateObj, locale, dateFormat),
        endDate: formatDate(endDateObj, locale, dateFormat)
      }
    };
  }, [startDate, endDate]);
  var apply = useMemo(function () {
    return {
      id: startDateErrorMsg.length > 0 || endDateErrorMsg.length > 0 ? '@dm/components.immersiveSubheader.date-filter.apply' : '@dm/components.immersiveSubheader.date-filter.error.apply-error-message'
    };
  }, [startDate, endDateObj]);
  var handleOnChange = useCallback(function () {
    onChange({
      startDate: formatDate(startDateObj, locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }),
      endDate: formatDate(endDateObj, locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    });
  }, [startDateObj, endDateObj, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dateFilterContainer
  }, /*#__PURE__*/React.createElement(ModalWrapper, null, function (_ref2) {
    var mounted = _ref2.mounted,
      triggerClose = _ref2.triggerClose,
      triggerOpen = _ref2.triggerOpen;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "date-filter-button",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: "@dm/components.immersiveSubheader.date-filter.label"
    }), ":"), /*#__PURE__*/React.createElement(AnchorButton, {
      id: "date-filter-button",
      onClick: triggerOpen
    }, /*#__PURE__*/React.createElement(ButtonLabel, {
      i18n: dateRange
    })), /*#__PURE__*/React.createElement(Modal, {
      mounted: mounted,
      className: "modal-insights-date-filter auto-insights-date-filter-alert",
      titleText: "@dm/components.immersiveSubheader.date-filter.header",
      includeCloseX: false,
      maxWidth: "520px",
      onExit: triggerClose
    }, /*#__PURE__*/React.createElement(IconButton, {
      className: "_dm-button--close-modal _dm-button--close-modal--ripple",
      onClick: triggerClose
    }, /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: "@dm/components.modal.close",
      hideLabel: true
    })), /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(H, null, /*#__PURE__*/React.createElement(I18n, {
      i18n: '@dm/components.immersiveSubheader.date-filter.header'
    })), /*#__PURE__*/React.createElement(I18n, {
      i18n: '@dm/components.immersiveSubheader.date-filter.header-instructions'
    })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(ButtonGroup, {
      position: "left"
    }, /*#__PURE__*/React.createElement(DateInput, {
      id: "start-date",
      errorMsg: startDateErrorMsg,
      label: "@dm/components.immersiveSubheader.date-filter.start-date",
      value: startDateObj,
      onChange: function onChange(e, value) {
        var startDateArr = value ? value.split('-') : [];
        if (startDateArr.length === 3) {
          var year = startDateArr[0];
          var month = startDateArr[1];
          var day = startDateArr[2];
          var newDate = year.slice(0, 4) + '-' + month.slice(0, 2) + '-' + day.slice(0, 2);
          if (newDate !== endDateObj) {
            setStartDateObj(newDate);
          }
        } else {
          setStartDateObj(value);
        }
      },
      onBlur: function onBlur(e) {
        var startDateArr = startDateObj ? startDateObj.split('-') : [];
        if (startDateArr && startDateArr.length < 3) {
          setStartDateObj('');
        }
        if (startDateObj && endDateObj && endDateObj < startDateObj) {
          setStartDateErrorMsg('@dm/components.immersiveSubheader.date-filter.error.start-date-before-end-date');
        } else {
          setStartDateErrorMsg('');
          setEndDateErrorMsg('');
        }
      }
    }), /*#__PURE__*/React.createElement(DateInput, {
      id: "end-date",
      errorMsg: endDateErrorMsg,
      label: "@dm/components.immersiveSubheader.date-filter.end-date",
      value: endDateObj,
      onChange: function onChange(e, value) {
        var endDateArr = value ? value.split('-') : [];
        if (endDateArr.length === 3) {
          var year = endDateArr[0];
          var month = endDateArr[1];
          var day = endDateArr[2];
          var newDate = year.slice(0, 4) + '-' + month.slice(0, 2) + '-' + day.slice(0, 2);
          if (newDate !== endDateObj) {
            setEndDateObj(newDate);
          }
        } else {
          setEndDateObj(value);
        }
      },
      onBlur: function onBlur(e) {
        var endDateArr = endDateObj ? endDateObj.split('-') : [];
        if (endDateArr && endDateArr.length < 3) {
          setEndDateObj('');
        }
        if (startDateObj && endDateObj && endDateObj < startDateObj) {
          setEndDateErrorMsg('@dm/components.immersiveSubheader.date-filter.error.end-date-before-start-date');
        } else {
          setEndDateErrorMsg('');
          setStartDateErrorMsg('');
        }
      }
    }))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Tooltip, {
      i18nKey: "@dm/components.immersiveSubheader.date-filter.cancel",
      direction: 'bottom'
    }, function (_ref3) {
      var ref = _ref3.ref,
        describedby = _ref3.describedby,
        events = _ref3.events;
      return /*#__PURE__*/React.createElement(Button, Object.assign({
        onClick: function onClick() {
          triggerClose();
          setStartDateObj(startDate ? startDateArray[2] + '-' + startDateArray[0] + '-' + startDateArray[1] : null);
          setEndDateObj(endDate ? endDateArray[2] + '-' + endDateArray[0] + '-' + endDateArray[1] : null);
        },
        className: "auto-modal-footer-button-cancel",
        ref: ref,
        "aria-describedby": describedby
      }, events), /*#__PURE__*/React.createElement(I18n, {
        i18n: '@dm/components.immersiveSubheader.date-filter.cancel'
      }));
    }), /*#__PURE__*/React.createElement(Tooltip, {
      i18nKey: apply,
      direction: 'bottom'
    }, function (_ref4) {
      var ref = _ref4.ref,
        describedby = _ref4.describedby,
        events = _ref4.events;
      return /*#__PURE__*/React.createElement(Button, Object.assign({
        onClick: function onClick() {
          handleOnChange();
          triggerClose();
        },
        className: "auto-modal-footer-button-confirm",
        modifier: "primary",
        disabled: startDateErrorMsg.length > 0 || endDateErrorMsg.length > 0,
        ref: ref,
        "aria-describedby": describedby
      }, events), /*#__PURE__*/React.createElement(I18n, {
        i18n: '@dm/components.immersiveSubheader.date-filter.apply'
      }));
    })))));
  }));
}
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(DateFilter);
export default enhanced;